function buildJsonPayload(
	values: NavigationItemFormValues
): Record<string, unknown> {
	const url =
		values.url && !/^https?:\/\//i.test(values.url)
			? `https://${values.url}`
			: values.url || "";

	const isGridParent = values.layout === "grid";
	const hasUrl = Boolean(values.url);

	return {
		name: values.name,
		description: values.description,
		permalink: values.permalink || null,
		parent: values.parent || null,
		url: isGridParent ? values.url || "" : url,
		web: isGridParent || !hasUrl ? false : values.openIn === "web",
		webview: isGridParent || !hasUrl ? false : values.openIn === "webview",
		published: values.published,
		layout: values.layout || null
	};
}

function buildFormData(
	values: NavigationItemFormValues,
	imageFile: File | null,
	imageRemoved: boolean
): FormData {
	const json = buildJsonPayload(values);
	const formData = new FormData();

	for (const [key, value] of Object.entries(json)) {
		if (value === null) {
			formData.append(key, "");
		} else if (typeof value === "boolean") {
			formData.append(key, String(value));
		} else {
			formData.append(key, String(value));
		}
	}

	if (imageFile) {
		formData.append("image", imageFile);
	} else if (imageRemoved) {
		formData.append("image", "");
	}

	return formData;
}

export const adaptCreateNavigationItemPayload = (
	values: NavigationItemFormValues,
	imageFile: File | null
): FormData | Record<string, unknown> => {
	if (imageFile) {
		return buildFormData(values, imageFile, false);
	}
	return buildJsonPayload(values);
};

export const adaptEditNavigationItemPayload = (
	values: NavigationItemFormValues,
	imageFile: File | null,
	imageRemoved = false
): FormData | Record<string, unknown> => {
	if (imageFile || imageRemoved) {
		return buildFormData(values, imageFile, imageRemoved);
	}
	return buildJsonPayload(values);
};
